/** Crossroads passes hash segments as strings; coerce before numeric compares. */
export function parseRouteParamVersion(raw: string | number | undefined | null): number | null {
    if (raw == null || raw === '') {
        return null;
    }
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
}

/** Whether the formtemplatev route version segment selects eHub v2. */
export function isFormTemplateV2(version: number): boolean {
    return version === 2;
}
